import React from "react";
import dayjs from "dayjs";
import {
  DismissedIcon,
  ImplementedIcon,
  ActiveIcon,
  AssignedIcon,
  BulkActionIcon,
  UnassignedIcon,
} from "@assets/icons";
import styles from "@/pages/query/styles.module.scss";

const TimelineEventIconWithDate = (
  owner?: string,
  status?: string,
  eventTime?: string
): React.ReactElement => {
  const isoDatetime = dayjs(eventTime);
  const formattedDate = dayjs(isoDatetime).format("MMM DD, YYYY");
  const formattedTime = dayjs(isoDatetime).format("hh:mm A");

  let eventType = "";
  if (owner && status) {
    eventType = "bulk";
  } else if (owner === "Unassigned") {
    eventType = "unassigned";
  } else if (owner) {
    eventType = "assigned";
  } else if (status === "Dismissed") {
    eventType = "dismissed";
  } else if (status === "Implemented") {
    eventType = "implemented";
  } else if (status === "Active") {
    eventType = "active";
  }

  switch (eventType) {
    case "bulk":
      return (
        <>
          <BulkActionIcon />
          <div className={styles.timeline_event_icon}>{formattedDate}</div>
          <div className={styles.timeline_event_icon_time}>{formattedTime}</div>
        </>
      );
    case "unassigned":
      return (
        <>
          <UnassignedIcon />
          <div className={styles.timeline_event_icon}>{formattedDate}</div>
          <div className={styles.timeline_event_icon_time}>{formattedTime}</div>
        </>
      );
    case "assigned":
      return (
        <>
          <AssignedIcon />
          <div className={styles.timeline_event_icon}>{formattedDate}</div>
          <div className={styles.timeline_event_icon_time}>{formattedTime}</div>
        </>
      );
    case "dismissed":
      return (
        <>
          <DismissedIcon />
          <div className={styles.timeline_event_icon}>{formattedDate}</div>
          <div className={styles.timeline_event_icon_time}>{formattedTime}</div>
        </>
      );
    case "implemented":
      return (
        <>
          <ImplementedIcon />
          <div className={styles.timeline_event_icon}>{formattedDate}</div>
          <div className={styles.timeline_event_icon_time}>{formattedTime}</div>
        </>
      );
    case "active":
      return (
        <>
          <ActiveIcon />
          <div className={styles.timeline_event_icon}>{formattedDate}</div>
          <div className={styles.timeline_event_icon_time}>{formattedTime}</div>
        </>
      );
    default:
      return (
        <>
          <BulkActionIcon />
          <div className={styles.timeline_event_icon}>{formattedDate}</div>
          <div className={styles.timeline_event_icon_time}>{formattedTime}</div>
        </>
      );
  }
};

export default TimelineEventIconWithDate;
